module.exports = (Promise.resolve(__parcel__require__("./" + "Doppio.535f641f.7194ebe0.js"))).then(() => parcelRequire('fyikB'));